import { memo } from "react";

import { cn } from "@/lib/chillnn/cn";

import { RadioGroup, RadioGroupItem } from "@/components/ui/input/radio-group";


type HolidayRadioOption = {
	id: string;
	label: string;
	value: string;
	/** ラベル下に表示する補足テキスト */
	hint?: string;
};

type Props = {
	sectionTitle: string;
	sectionDescription: string;
	options: HolidayRadioOption[];
	value: string;
	onValueChange: (value: string) => void;
	className?: string;
};

export const HolidayStayableRadioSubBlock = memo(
	({ sectionTitle, sectionDescription, options, value, onValueChange, className }: Props) => {
		return (
			<div className={cn("pt-2", className)}>
				<fieldset className="min-w-0 space-y-2 rounded-md border border-border bg-muted/30 p-3">
					<legend className="px-2 text-sm font-medium text-foreground">{sectionTitle}</legend>
					<p className="text-sm text-caption-50">{sectionDescription}</p>
					<RadioGroup onValueChange={onValueChange} value={value}>
						{options.map(({ id, label, value: optionValue, hint }) => (
							<div key={id} className="flex items-start space-x-3 space-y-0">
								<RadioGroupItem value={optionValue} id={id} className="mt-0.5 shrink-0" />
								<div className="grid gap-0.5">
									<label htmlFor={id} className="text-sm leading-4">
										{label}
									</label>
									{hint && (
										<p className="text-xs leading-4 text-caption-50">{hint}</p>
									)}
								</div>
							</div>
						))}
					</RadioGroup>
				</fieldset>
			</div>
		);
	},
);

HolidayStayableRadioSubBlock.displayName = "HolidayStayableRadioSubBlock";
